import { apiGet, apiPostFormUrlEncoded, FormUrlEncodedBody, toLegacyAjaxError } from '@shared/api/apiClient';


var baseUrl = '';
var graphicBasePath = '/FacilityApi';
var lodBasePath = '/Media';
var graphicApiPath = '/api/graphicdata';
var graphicRequest = '/GraphicDataByReference';
var graphicRequestInfo = '/GraphicalRequestInfo'
var appearanceRequest = '/Appearances';
var extentRequest = '/Extents';
var graphicAppearanceRequest = '/GraphicAppearanceByReference';
var octreeRequest = '/OctreesByReference';
var assetSetOctreesRequest = '/OctreesByAssetSets';
var octreeDataRequest = '/GraphicDataByDisplayList';
var overrideGraphicDataOctreeRequestUrl = '';
var overrideGraphicRequestUrl = '';
var overrideRequestInfoUrl = '';
var overrideAppearanceRequestUrl = '';
var overrideExtentUrl = '';

type ViewerAbortableRequest = Promise<void> & {
    abort: () => ViewerAbortableRequest;
    readyState: number;
    status: number;
    statusText: string;
};

function createViewerRequest<T>(request: Promise<T>, controller: AbortController, successCallback: (retData: T) => void, errorCallback: (error: IServiceErrorObject) => void): JQueryXHR {
    const abortable = request
        .then((retData) => {
            abortable.readyState = 4;
            abortable.status = 200;
            abortable.statusText = 'success';
            successCallback(retData);
        })
        .catch((error) => {
            const legacyError = toLegacyAjaxError(error);
            abortable.readyState = legacyError.readyState;
            abortable.status = legacyError.status;
            abortable.statusText = legacyError.statusText;
            errorCallback(legacyError);
        }) as ViewerAbortableRequest;

    abortable.readyState = 1;
    abortable.status = 0;
    abortable.statusText = '';
    abortable.abort = () => {
        controller.abort();
        abortable.readyState = 0;
        abortable.status = 0;
        abortable.statusText = 'abort';
        return abortable;
    };

    return abortable as unknown as JQueryXHR;
}

function getGraphicUrl() {
    return getGraphicBaseUrl() + graphicApiPath;
}

function getLodUrl() {
    return baseUrl + lodBasePath;
}

function getGraphicBaseUrl() {
    return baseUrl + graphicBasePath;
}

function getOctreeRequestUrl() {
    if (overrideGraphicRequestUrl.length > 0) return overrideGraphicRequestUrl;
    return getGraphicUrl() + octreeRequest;
}
function getAssetSetOctreesRequestUrl() {
    return getGraphicUrl() + assetSetOctreesRequest;
}
function getGraphicDataOctreeRequestUrl() {
    if (overrideGraphicRequestUrl.length > 0) return overrideGraphicDataOctreeRequestUrl;
    return getGraphicUrl() + octreeDataRequest
}

function getLodDataRequestUrl() {
    return getLodUrl();
}

function getGraphicDataRequestUrl() {
    if (overrideGraphicRequestUrl.length > 0) return overrideGraphicRequestUrl;
    return getGraphicUrl() + graphicRequest;
}

function getGraphicDataRequestInfoUrl() {
    if (overrideRequestInfoUrl.length > 0) return overrideRequestInfoUrl;
    return getGraphicUrl() + graphicRequestInfo;
}

function getExtentUrl() {
    if (overrideRequestInfoUrl.length > 0) return overrideExtentUrl;
    return getGraphicUrl() + extentRequest;
}

function getAppearanceRequestUrl() {
    if (overrideAppearanceRequestUrl.length > 0) return overrideAppearanceRequestUrl;
    return getGraphicUrl() + appearanceRequest;
}

function getGraphicAppearanceUrl() {
    if (overrideAppearanceRequestUrl.length > 0) return overrideAppearanceRequestUrl;
    return getGraphicUrl() + graphicAppearanceRequest;
}

var Viewer3DService = {
    setBaseUrl: function (url: string) {
        baseUrl = url;
    },
    getGraphicDataRequestUrl() {
        return getGraphicDataRequestUrl();
    },
    getGraphicDataOctreeRequestUrl() {
        return getGraphicDataOctreeRequestUrl();
    },
    getLodDataRequestUrl() {
        return getLodDataRequestUrl();
    },
    overrideGraphicDataRequestUrl(overrideUrl: string) {
        overrideGraphicRequestUrl = overrideUrl;
    },

    overrideAppearanceRequestUrl(overrideUrl: string) {
        overrideAppearanceRequestUrl = overrideUrl;
    },

    overrideGraphicRequestInfoUrl(overrideUrl: string) {
        overrideRequestInfoUrl = overrideUrl;
    },

    getGraphicBaseUrl() {
        return getGraphicBaseUrl();
    },

    get: function (url: string, data: FormUrlEncodedBody, succesCallback: any, errorCallback: any) {
        var controller = new AbortController();
        return createViewerRequest(
            apiGet(url, data, { signal: controller.signal, cache: 'no-store' }),
            controller,
            succesCallback,
            errorCallback,
        );
    },

    post: function (url: string, data: FormUrlEncodedBody, successCallback: any, errorCallback: any) {
        var controller = new AbortController();
        return createViewerRequest(
            apiPostFormUrlEncoded(url, data, { signal: controller.signal, responseType: 'json', cache: 'no-store' }),
            controller,
            successCallback,
            errorCallback,
        );
    },

    

    getOctree: function (graphicsRequest: OctreeRequest, successCallback: any, errorCallback: any) {
        var that = this;
        return this.post(getOctreeRequestUrl(),
            graphicsRequest,
            function (retData: any) {
                if (typeof retData === 'string') {
                    retData = JSON.parse(retData);
                }
                successCallback(retData);
            },
            function (error: any) {
                console.log(error);
                errorCallback(error);
            });

    },
    getAssetSetOctrees: function (graphicsRequest: any, successCallback: any, errorCallback: any) {
        var that = this;
        return this.post(getAssetSetOctreesRequestUrl(),
            graphicsRequest,
            function (retData: any) {
                if (typeof retData === 'string') {
                    retData = JSON.parse(retData);
                }
                successCallback(retData);
            },
            function (error: any) {
                console.log(error);
                errorCallback(error);
            });

    },
    getGraphics: function (graphicsRequest: GraphicsRequest, successCallback: any, errorCallback: any) {
        var that = this;
        return this.post(getGraphicDataRequestUrl(),
            graphicsRequest,
            function (retData: any) {
                if (typeof retData === 'string') {
                    retData = JSON.parse(retData);
                }
                successCallback(retData);
            },
            function (error: any) {
                console.log(error);
                errorCallback(error);
            });

    },

    getAppearances: function (appearanceRequest: AppearanceRequest, successCallback: any, errorCallback: any) {
        var that = this;
        return this.get(getAppearanceRequestUrl(),
            appearanceRequest,
            function (retData: any) {
                if (typeof retData === 'string') {
                    retData = JSON.parse(retData);
                }
                successCallback(retData);
            },
            function (error: any) {
                console.log(error);
                errorCallback(error);
            });
    },
    getGraphicAppearance: function (graphicsRequest: GraphicsRequest, successCallback: any, errorCallback: any) {
        var that = this;
        return this.post(getGraphicAppearanceUrl(),
            graphicsRequest,
            function (retData: any) {
                if (typeof retData === 'string') {
                    retData = JSON.parse(retData);
                }
                successCallback(retData);
            },
            function (error: any) {
                console.log(error);
                errorCallback(error);
            });
    },
    getObjectExtents: function (extentRequest: ExtentRequest, successCallback: any, errorCallback: any) {
        var that = this;
        return this.post(getExtentUrl(),
            extentRequest,
            function (retData: any) {
                if (typeof retData === 'string') {
                    retData = JSON.parse(retData);
                }
                successCallback(retData);
            },
            function (error: any) {
                console.log(error);
                errorCallback(error);
            });
    },

    getGraphicalRequestInfo: function (graphicsRequest: GraphicsRequestBase, successCallback: any, errorCallback: any) {
        var that = this;
        return this.post(getGraphicDataRequestInfoUrl(),
            graphicsRequest,
            function (retData: any) {
                if (typeof retData === 'string') {
                    retData = JSON.parse(retData);
                }
                successCallback(retData);
            },
            function (error: any) {
                console.log(error);
                errorCallback(error);
            });
    }

};

export default Viewer3DService;